import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg xmlns="http://www.w3.org/2000/svg" width="29" height="20" viewBox="0 0 29 20" {...this.props}><path fillRule="evenodd" fill="#CC181E" d="M28.221 15.449s-.274 1.882-1.113 2.71c-1.065 1.087-2.259 1.093-2.806 1.156-3.918.276-9.802.285-9.802.285s-7.28-.065-9.52-.274c-.623-.114-2.022-.08-3.087-1.167-.84-.828-1.113-2.71-1.113-2.71S.5 13.241.5 11.031V8.96c0-2.209.28-4.418.28-4.418s.273-1.881 1.113-2.71C2.958.745 4.151.74 4.698.676 8.617.4 14.494.4 14.494.4h.012s5.878 0 9.796.276c.547.064 1.741.069 2.806 1.156.839.829 1.113 2.71 1.113 2.71s.279 2.209.279 4.418v2.071c0 2.21-.279 4.418-.279 4.418zM11.609 5.871v7.67l7.565-3.822-7.565-3.848z" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/static/images/sources/youtube.svg